// Centralised data-testid registry — keep stable for QA & testing agent.
export const TESTIDS = {
  // Layout
  headerLogo: "header-logo",
  headerCartBtn: "header-cart-btn",
  headerMenuBtn: "header-menu-btn",
  headerSearchBtn: "header-search-btn",
  headerAccountBtn: "header-account-btn",
  mobileMenu: "mobile-menu",
  mobileMenuClose: "mobile-menu-close",
  searchOverlay: "search-overlay",
  searchInput: "search-input",
  searchClose: "search-close",
  searchResult: (slug) => `search-result-${slug}`,
  // Home (Iteration 7)
  homeHero: "home-hero",
  homeHeroCta: "home-hero-cta",
  homeCategoryTile: (slug) => `home-cat-${slug}`,
  homeTotalLookCta: "home-total-look-cta",
  homeTotalLookCard: (slug) => `home-total-look-${slug}`,
  homeLookbookTitle: "home-lookbook-title",
  homeStoryCta: "home-story-cta",
  // Collection
  collectionGrid: "collection-grid",
  collectionFilter: (cat) => `collection-filter-${cat}`,
  productCard: (slug) => `product-card-${slug}`,
  productCardLink: (slug) => `product-card-link-${slug}`,
  productCardTrending: (slug) => `product-card-trending-${slug}`,
  // PDP
  pdpGallery: "pdp-gallery",
  pdpGalleryItem: (i) => `pdp-gallery-item-${i}`,
  pdpName: "pdp-name",
  pdpPrice: "pdp-price",
  pdpSku: "pdp-sku",
  pdpVariantChip: (name) => `pdp-variant-${name.replace(/[^a-zA-Z0-9]/g, "-")}`,
  pdpQtyMinus: "pdp-qty-minus",
  pdpQtyPlus: "pdp-qty-plus",
  pdpAddToCart: "pdp-add-to-cart",
  pdpStickyAtc: "pdp-sticky-atc",
  pdpModelWearing: "pdp-model-wearing",
  pdpShopTheLook: "pdp-shop-the-look",
  pdpShopLookAdd: "pdp-shop-look-add",
  pdpReviewsSection: "pdp-reviews",
  pdpReviewForm: "pdp-review-form",
  pdpReviewSubmit: "pdp-review-submit",
  pdpReviewTitle: "pdp-review-title",
  pdpReviewBody: "pdp-review-body",
  pdpReviewPhotos: "pdp-review-photos",
  pdpReviewRating: (n) => `pdp-review-rating-${n}`,
  pdpTrendingBadge: "pdp-trending-badge",
  // Cart
  cartDrawer: "cart-drawer",
  cartDrawerClose: "cart-drawer-close",
  cartItem: (i) => `cart-item-${i}`,
  cartItemRemove: (i) => `cart-item-remove-${i}`,
  cartCheckoutBtn: "cart-checkout-btn",
  cartSubtotal: "cart-subtotal",
  cartBundleLine: "cart-bundle-line",
  cartTotal: "cart-total",
  cartEmpty: "cart-empty",
  // Auth
  authModal: "auth-modal",
  authTabLogin: "auth-tab-login",
  authTabRegister: "auth-tab-register",
  authEmail: "auth-email",
  authPassword: "auth-password",
  authName: "auth-name",
  authSubmit: "auth-submit",
  authClose: "auth-close",
  authGoogleBtn: "auth-google-btn",
  // Checkout result
  checkoutStatusBox: "checkout-status",
};
